import { Attribution } from 'types'

interface Params {
  endDate: string
  startDate: string
  attr: Attribution
}

// Sums only source-level rows where channel_id IS NOT NULL — i.e. truly attributed sessions.
// Uses <> 'null' which stringify.js converts to "is not null" in the final ClickHouse query.
export const getAttributedSourcesSum = ({ endDate, startDate, attr }: Params) => {
  const where = `WHERE stats.channel_id <> 'null' AND stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}'`
  switch (attr) {
    case 'first':
      return `SELECT SUM(first.total_amount), SUM(first.orders_amount), SUM(first.total_orders), SUM(first.leads), SUM(first.new_customers) FROM source ${where}`
    case 'last':
      return `SELECT SUM(last.total_amount), SUM(last.orders_amount), SUM(last.total_orders), SUM(last.leads), SUM(last.new_customers) FROM source ${where}`
    case 'linear':
      return `SELECT SUM(linear_source.total_amount), SUM(linear_source.orders_amount), SUM(linear_source.total_orders), SUM(linear_source.leads), SUM(stats.new_customers) FROM source ${where}`
    case 'ai':
      return `SELECT SUM(ai_source.total_amount), SUM(ai_source.orders_amount), SUM(ai_source.total_orders), SUM(ai_source.leads), SUM(stats.new_customers) FROM source ${where}`
    default:
      return ''
  }
}
